import { Form as HeroForm, FormProps as HeroFormProps } from "@heroui/react";
import clsx from "clsx";

export type FormProps = Omit<HeroFormProps, "children"> & {
  children: React.ReactNode;
  ref?: React.Ref<HTMLFormElement>;
};

export function Form({ ref, ...props }: FormProps) {
  return (
    <HeroForm
      {...props}
      ref={ref}
      className={clsx("flex flex-col gap-4", props.className)}
    />
  );
}

Form.displayName = "Recare.Form";
